var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "formpart range_input"
    },
    [
      _c(
        "input",
        _vm._g(
          _vm._b(
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.myValue,
                  expression: "myValue"
                }
              ],
              attrs: {
                type: "range",
                name: _vm.name,
                min: _vm.min,
                max: _vm.max,
                step: _vm.step,
                "aria-valuemin": _vm.min,
                "aria-valuemax": _vm.max,
                "aria-valuenow": _vm.myValue
              },
              domProps: {
                value: _vm.myValue
              },
              on: {
                __r: function __r($event) {
                  _vm.myValue = $event.target.value
                }
              }
            },
            "input",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c(
        "output",
        {
          attrs: {
            for: "fader"
          }
        },
        [
          _c(
            "translate",
            {
              attrs: {
                "translate-params": {
                  myValue: _vm.myValue || "1",
                  max: _vm.max
                }
              }
            },
            [_vm._v("%{myValue} von %{max}")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }